export interface RoleSummaryDto {
    map: string;
    side: string;
    roleCategory: string;
    roleName: string;
    rounds: number;
    lastPlayed: string;
}

export const roleDisplayNames: Record<string, string> = {
    'lurk': 'Lurker',
    'half_lurk': 'Half Lurk',
    'pack': 'Pack',
    't_allround': 'Allround',
    'anchor': 'Anchor',
    'rotation': 'Rotation',
    'ct_allround': 'Allround',
    'awp': 'AWPer',
};

// Dominant computed role across all maps/sides, by rounds played.
// AWP promotion: if awp rounds exist but aren't dominant, promote when >= 20% of total.
export const computeDominantRole = (mapRoles: RoleSummaryDto[] | undefined | null): string | null => {
    if (!mapRoles || mapRoles.length === 0) return null;
    const counts: Record<string, number> = {};
    for (const r of mapRoles) {
        counts[r.roleCategory] = (counts[r.roleCategory] || 0) + r.rounds;
    }
    let best = '';
    let bestRounds = 0;
    for (const [cat, rounds] of Object.entries(counts)) {
        if (rounds > bestRounds) {
            best = cat;
            bestRounds = rounds;
        }
    }
    if (best !== 'awp' && counts['awp'] > 0) {
        const totalRounds = Object.values(counts).reduce((a, b) => a + b, 0);
        if (counts['awp'] / totalRounds >= 0.2) best = 'awp';
    }
    return best ? (roleDisplayNames[best] || best) : null;
};

export interface RoleTooltipLine {
    map: string;
    t: string;
    ct: string;
}

const formatMapName = (mapName: string): string => {
    const cleanName = mapName.replace('de_', '');
    return cleanName.charAt(0).toUpperCase() + cleanName.slice(1);
};

// Per-map T/CT role lines for the "Beregnet rolle" tooltip.
export const buildRoleTooltipLines = (mapRoles: RoleSummaryDto[] | undefined | null): RoleTooltipLine[] => {
    if (!mapRoles || mapRoles.length === 0) return [];
    const mapGroups: Record<string, { t?: string; ct?: string }> = {};
    for (const r of mapRoles) {
        if (!mapGroups[r.map]) mapGroups[r.map] = {};
        const label = roleDisplayNames[r.roleCategory] || r.roleCategory;
        if (r.side === 'T') mapGroups[r.map].t = label;
        if (r.side === 'CT') mapGroups[r.map].ct = label;
    }
    return Object.entries(mapGroups).map(([map, roles]) => ({
        map: formatMapName(map),
        t: roles.t || '-',
        ct: roles.ct || '-',
    }));
};
